import { setAppNotice } from '@/app/store/appShellSlice';
import { handleUnwrapRTKError } from '@/services/utils/handlers';

type DispatchFn = (action: ReturnType<typeof setAppNotice>) => void;

export type NotifyAppErrorOptions = {
  endpointName: string;
  fallbackMessage: string;
  action?: string;
};

/**
 * Centraliza el despacho de AppNotice cuando un endpoint falla.
 * Se obtiene el error transformado y se preservan los detalles/validaciones.
 */
export const notifyAppError = (
  dispatch: DispatchFn,
  err: unknown,
  { endpointName, fallbackMessage, action }: NotifyAppErrorOptions,
) => {
  const parsed = handleUnwrapRTKError(err);
  dispatch(
    setAppNotice({
      message: parsed?.message || fallbackMessage,
      status: parsed?.code ?? null,
      details: `Endpoint: ${endpointName}${parsed?.code ? ` — Código: ${parsed.code}` : ''}`,
      action: action ?? endpointName,
      endpointName,
      validationErrors: (parsed as any)?.details ?? (parsed as any)?.originalError?.errors ?? {},
    }),
  );
};
